import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import moment from 'moment';
import { CoreService } from '../../../../core/services/core.service';

@Component({
  selector: 'app-live-timeline',
  standalone: true,
  imports: [],
  templateUrl: './live-timeline.component.html',
  styleUrl: './live-timeline.component.css'
})
export class LiveTimelineComponent implements OnInit, OnDestroy {
  @Input() id?: string;

  currentDate: string = '';
  private timerSub?: Subscription;

  constructor(private core: CoreService) {}

  ngOnInit(): void {
    this.tick();

    this.timerSub = interval(1000).subscribe(() => {
      this.tick();
    });
  }

  private tick(): void {
    const mili = Date.now();
    this.currentDate = moment(mili).format('MMM Do YYYY  h:mm:ss A');
    try {
      this.core.setCurrentTimestamp(mili);
    } catch (e) {
    }
  }

  ngOnDestroy(): void {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
      this.timerSub = undefined;
    }
  }
}